import React, { Component } from 'react';
import FilterBasic from '../../basicElement/FilterBasic';
import moment from 'moment';

class Filter extends Component {

    disabledDate = (current) => {
        const { currentDate } = this.props;
        const startOfRange = moment(currentDate).subtract(3, 'months').startOf('month');
        const endOfRange = moment(currentDate).endOf('month');
        return current < startOfRange || current > endOfRange;
    }

    render() {
        const { ...rest } = this.props;
        const { curRole } = sessionStorage;
        const filters = [{
            name: '工作日期',
            key: 'begin',
            type: 'rangePicker',
            typeProperty: {
                keys: ['begin', 'end'],
                disabledDate: curRole === 'CRC' ? this.disabledDate : undefined,
            }
        }];
        return (
            <FilterBasic filters={filters} {...rest} />
        )
    }
}

export default Filter;


// WEBPACK FOOTER //
// ./src/components/sumTotal/weeklySummary/Filter.js